import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollUpdateDeductionsRequest, UpdateDeductionsResponse } from '../types';

export const updateDeductionsMutation = gql`
  mutation PayrollUpdateDeductions($assignments: [DeductionAssignmentRequestItemInput!]) {
  payrollUpdateDeductions(assignments: $assignments) {
    data {
      data {
        id
        componentId
        componentName
        userId
        amount
        effectiveFrom
        effectiveTo
        type
        componentDetails {
          id
          name
          description
          defaultFormula
          category
          settings {
            behaviour {
              pfBehaviour {
                includeInPfWages
              }
              ptBehaviour {
                includeInPtWages
              }
              esiBehaviour {
                includeInEsiWages
              }
              lwfBehaviour {
                includeInLwfWages
              }
              taxBehaviour {
                taxExemptionSection
                taxDeductionBehaviour
                taxExemptInNewRegime
                taxExemptInOldRegime
              }
              arrearBehaviour {
                considerInArrear
              }
              prorationBehaviour {
                supportProration
              }
              displayBehaviour {
                showZero
                visibleToEmployee
                displayName
              }
            }
            earningDetails {
              payType
            }
            deductionDetails {
              deductionType
              deductFrom
            }
            bonusDetails {
              clawbackDuration
              isTaxable
            }
            perquisiteDetails {
              isTaxable
            }
            nonPayableBenefitsDetails {
              isPartOfCTC
              visibilityToEmployee
            }
          }
          isPredefined
          isActive
          source
          
        }
      }
      source
    }
    code
    success
    message
  }
}
`;

const updateDeductions = (queryVariables: PayrollUpdateDeductionsRequest) => {
  return graphQLApi<UpdateDeductionsResponse, PayrollUpdateDeductionsRequest>({
    query: updateDeductionsMutation,
    queryVariables,
  });
};

export default updateDeductions;